import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, MapPin, Clock } from "lucide-react";
import { Logo } from "@/components/Brand";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <footer className="bg-metros-black text-white grain mt-16 pb-24 md:pb-0" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Logo dark />
          <p className="text-sm text-gray-400 mt-3 max-w-xs">{s.hero?.subtext || "Good food. Made for you."}</p>
          <div className="flex gap-3 mt-4">
            <a href={s.social?.instagram || "#"} target="_blank" rel="noreferrer" className="bg-white/10 hover:bg-metros-red rounded-full p-2 transition-colors"><Instagram size={18} /></a>
            <a href={s.social?.facebook || "#"} target="_blank" rel="noreferrer" className="bg-white/10 hover:bg-metros-red rounded-full p-2 transition-colors"><Facebook size={18} /></a>
          </div>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><Link to="/menu" className="hover:text-white">Menu</Link></li>
            <li><Link to="/offers" className="hover:text-white">Offers</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-3">Order</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><Link to="/menu" className="hover:text-white">Order Online</Link></li>
            <li className="flex items-center gap-1.5"><Clock size={13} /> Delivery & Collection</li>
            <li>{s.delivery?.estimated_time || "30-45 mins"} delivery</li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-3">Contact</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li className="flex items-start gap-1.5"><MapPin size={14} className="mt-0.5" /> {s.address}</li>
            <li className="flex items-center gap-1.5"><Phone size={13} /> {s.phone}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between gap-2 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} Metros Franchise. All rights reserved.</span>
          <div className="flex gap-4">
            <Link to="/legal/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/legal/terms" className="hover:text-white">Terms</Link>
            <Link to="/legal/cookies" className="hover:text-white">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
